import { create } from 'zustand';

// Per-channel "select this list" request. The Prescription panel's "Show all in
// Ward" / "Commit to Roll-Up Foundation" actions use it to drive an ALREADY-OPEN
// Ward / Roll-Up on the same channel to SELECT the watchlist/foundation they just
// created — rather than silently persisting it (the old behaviour) or stacking
// duplicate panels. A freshly-opened Ward/Roll-Up reads it on mount too, so one
// path covers both "reuse the linked panel" and "pop a new one".
//
// `kind` keeps a watchlist request from steering a Roll-Up (and vice versa).
// `nonce` lets the same id be re-requested (force a re-select). Keyed by the
// channel — `${tabId}:${groupId}` (same key as catchment-link).

export type SelectKind = 'watchlist' | 'foundation';
export interface SelectRequest {
  kind: SelectKind;
  id: string;
  nonce: number;
}

interface SelectLinkState {
  byKey: Record<string, SelectRequest | null>;
  request: (key: string, kind: SelectKind, id: string) => void;
}

let seq = 0;

export const useSelectLink = create<SelectLinkState>((set) => ({
  byKey: {},
  request: (key, kind, id) =>
    set((s) => ({ byKey: { ...s.byKey, [key]: { kind, id, nonce: ++seq } } })),
}));
